import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../utils/analytics';

/**
 * Component to track page views on SPA navigation
 * Automatically fires GA4 page_view events on route changes
 */
const GA4PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    trackPageView(location.pathname, document.title);
  }, [location]);

  return null;
};

export default GA4PageTracker;
